import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})
export class SvgService {
    constructor(
        private readonly _registry: MatIconRegistry,
        private readonly _sanitizer: DomSanitizer
    ) {}

    register(iconName: string, url: string) {
        this._registry.addSvgIcon(
            iconName,
            this._sanitizer.bypassSecurityTrustResourceUrl(url)
        );
    }
}
